export class PermanentError extends Error {
  constructor(
    message?: string,
    readonly cause?: unknown
  ) {
    super(message);
  }
}
